import { computed, observable } from 'mobx';

export default class ElementGrid {
  @observable
  id;
  @observable
  elementId;
  @observable
  name;
  @observable
  displayType;

  constructor(id, elementId, name, displayType) {
    this.id = id || '';
    this.elementId = elementId || '';
    this.name = name || '';
    this.displayType = displayType || '';
  }

  @computed
  get nameValid() {
    if (this.name.length < 1) {
      return false;
    }
    return true;
  }

  @computed
  get nameError() {
    if (this.name.length < 1) {
      return I18n.t('js.name_is_required');
    }
    return null;
  }
}
